export default ['vbkdcl', 'rga'];
